module.exports = __webpack_public_path__ + "assets/img/wangluo.f34b3dc0.png";